var _style, _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3000 2250",
    style: {
      enableBackground: "new 0 0 3000 2250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#DAFADD;}\n\t.st2{fill:#EBF2FF;}\n\t.st3{fill:none;stroke:#00B60F;stroke-width:7;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:#003188;stroke-width:7;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:#003188;stroke:#003188;stroke-width:7;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st6{fill:#003188;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 3000,
    height: 2250
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "color_shadow"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1300.4,962.8c-0.2,18.7,1.1,43.4,0.9,62.1c-0.1,4.8,415.9,4.7,420.1-1.5c9.8-14.2,28.5-44.7,37.8-59.2 C1763.1,958.4,1300.5,954.6,1300.4,962.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2012.9,1645.4c-28.5,8.4-109.6,7.8-101.8,22.9c2.6,5.1,1.9,11.3,2.8,17c0.5,2.8,3.5,5.8,6.3,6.3 c22.1,3.8,94.9,0,98.7-3.9c4.2-4.2,5-27.7,5.4-33.6C2024.6,1648.3,2018.2,1643.8,2012.9,1645.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1886,1447.2c0,26.8,5,53.3,7.6,79.9c0.5,5,3.7,8.7,9,9c34.3,1.8,68.8-1,102.3-8.3c7.8-1.7,16.8-2.9,24-6.3 c8.9-4.3,12.9-63.4,12.9-81.3C2008.2,1440.2,1886,1435.1,1886,1447.2z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "shadow"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M889,813.6c11.3,18.2,13.8,69.5,38.5,73.9c34.1,6.1,35.9-52.1,34.3-71.3c-2.9-32.9-20.5-70-5.8-102.6 c14.6-32.3,52.5-33.4,71.4-59.9c49.5-69.3-67.4-52.3-96.8-31.3C871.3,664.9,850.5,751.5,889,813.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1055.5,622.6c26.8,15.2,109.7,13.7,106.1-32.5c-3-38.5-42.1-9.8-58.9-1.3 C1096.7,591.8,1034.5,610.7,1055.5,622.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1084.8,806c-32.1-21.6-44.7,27.1-11.5,38.9C1104.4,856,1108,821.6,1084.8,806z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1128,909.7c-11.6,13.2,22.5,27.1,30.1,10.7C1166.3,903,1137.9,898.5,1128,909.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1133,1045.1c39-9.2-4.2-31.3-14.6-35.6c-27.9-11.5-58.7-19.1-88-26.2c-29.8-7.3-160.7-44.7-176-15.4 c-24.7,47.2,66.7,46.1,89.3,48.8c35.3,4.2,70.4,10.2,105.4,16.3C1073.4,1037.2,1108.9,1050.8,1133,1045.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M736.6,1138.2c-76.5,67.5-77.6,176.3-105.2,267.2c-13.7,45.1-39.2,86.7-47.4,133.4 c-5.3,29.8-6.5,144.3,31.7,158c26.1,9.4,18.9-111.7,20.8-136.1c3.9-51,10.4-101.8,19.6-152.1c10.5-57,24.3-113.4,41.5-168.8 c9.2-29.6,19-49.3,37.2-74.2C732.7,1168.2,762.7,1115.2,736.6,1138.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M989.8,1577.2c-37.2-81.3-63.9-155.1-88.2-240.5c-6.2-21.9-36.8-96.3-59.7-46.2c-12.5,27.3-2.7,83-2.1,112.7 c1.7,83.4,11.2,186.5,66.1,254.2c20.5,25.3,66.9,60.9,95.1,25.7C1024.3,1653.8,1002.6,1605.3,989.8,1577.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1403.9,1704.3c-63.6-30.8-124.7-75.2-160.8-137.2c-37.8-64.9-41.8-144.5-72.1-213 c-32.7-73.8-40.9-135.5-24.6-214.9c2.8-13.4,20.6-73.9-9.6-57c-20.7,11.6-32,80.4-36.4,100.4c-17.2,79.2,5.3,145.1,26,220.7 c19.8,72.1,12.9,153.3,48.3,220.6c32.2,61.1,95.6,109.7,160.6,131.3c23.2,7.7,67.3,19,90.7,5.4 C1463.3,1739.1,1429.5,1716.7,1403.9,1704.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1279.8,1539.1c24.7,19.5,78.8,44.9,100.9,8.2c21.9-36.3-25.6-80.3-51.7-98.8c-24-17-67.5-41.7-90.3-10.1 C1215.6,1470.5,1255.2,1519.7,1279.8,1539.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1809.4,1691.4c-7.5-53.7-24.8-155.2-72.8-187.8c-13.5-9.1-57.8-23.2-69.7-10.2 c-13.6,14.8,7.3,41.5,13.5,55.8c14.1,32.1,25.2,65.6,33.4,99.7c5.5,22.8,3.3,60.9,13.4,81.5c10.2,20.6,41.9,28.7,66.8,18.6 C1820.8,1738.1,1813.5,1721.3,1809.4,1691.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2312,1168.6c-3.1-21-474.2-4.2-524.2-4.2c-93.6,0-187.1-0.2-280.7-0.4c-46.2-0.1-94.4-4.5-140.4-0.4 c-58.5,5.2-10.7,31.3,11.8,60.7c2.2,2.9-12.4,9.2,2.7,17.6c13.5,7.5,53.2-0.2,67.8-0.3c45.2-0.1,90.4-0.2,135.5-0.2 c92.6,0,185.3,0.2,277.9,0.7c91.2,0.5,182.4,1.3,273.5,2.3c45.3,0.5,90.5,1.1,135.8,1.8C2329,1247.1,2320,1224,2312,1168.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1824.9,1275.3c-0.5-12.1-174-10.5-193.5-10.3c-60.3,0.6-47.2-4.6-49,37c-1.8,42.4-38.1,44.6-55,78.6 c-18.8,37.7,37.1,22.7,65,22.3c38.4-0.5,76.7-0.8,115.1-0.8c41.6,0.1,56.5-7.4,86.7-36.2C1828,1333.6,1826.8,1322.7,1824.9,1275.3 z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "color_outline"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1301.4,
    y: 958.8,
    className: "st3",
    width: 722.4,
    height: 66.2
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "1614.9,828.8 1614.9,861.4 1808.8,861.4  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 1808.8,
    y1: 828.8,
    x2: 1808.8,
    y2: 861.4
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "1676.3,774.9 1711.9,824.1 1711.9,702.4  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 1747.5,
    y1: 774.9,
    x2: 1711.9,
    y2: 824.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 1361,
    y1: 960.2,
    x2: 1321.2,
    y2: 1023.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 1418.1,
    y1: 960.2,
    x2: 1378.4,
    y2: 1023.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 1475.3,
    y1: 960.2,
    x2: 1435.6,
    y2: 1023.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 1532.5,
    y1: 960.2,
    x2: 1492.8,
    y2: 1023.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 1589.7,
    y1: 960.2,
    x2: 1549.9,
    y2: 1023.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 1646.9,
    y1: 960.2,
    x2: 1607.1,
    y2: 1023.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 1704.1,
    y1: 960.2,
    x2: 1664.3,
    y2: 1023.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 1761.3,
    y1: 960.2,
    x2: 1721.5,
    y2: 1023.5
  })), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 1248,
    y1: 479.4,
    x2: 1371.8,
    y2: 516.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 1359.8,
    y1: 412.2,
    x2: 1415.3,
    y2: 498.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 1858.5,
    y1: 1440.2,
    x2: 2089.9,
    y2: 1440.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 1858.5,
    y1: 1428.3,
    x2: 2089.9,
    y2: 1428.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 1882.9,
    y1: 1444.5,
    x2: 1893.1,
    y2: 1532.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 1910.5,
    y1: 1660.2,
    x2: 1912.7,
    y2: 1679.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 2060.7,
    y1: 1443.1,
    x2: 2052.5,
    y2: 1513.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 2043.2,
    y1: 1637.3,
    x2: 2038.2,
    y2: 1680.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 1911.6,
    y1: 1691.8,
    x2: 2036.2,
    y2: 1691.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 1914.7,
    y1: 1704.4,
    x2: 2036.2,
    y2: 1704.4
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "outline"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1019.8,600c-24.2-4.2-76.6-0.3-114.9,44.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M890.7,647.9c-3.3-12.2-5.5-24.6-6.6-37.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M850.9,639.7c9.4,1.7,18.2,6.8,24.3,14.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M887,669.8c-12.7,18.9-21.2,40.6-24.8,63c-2.3,14.3-2.5,29.3,1.9,43.1c5.3,16.9,16.9,31.1,25.8,46.4 c11.6,19.9,18.8,42.3,21.1,65.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M914.5,903.1c0.7,15.3,1.4,30.6,2.1,45.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M935.8,892.2c18.2-1,36.7-4.9,52.3-14.4c15.6-9.5,28-25.3,30.4-43.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1050,779.2c-5.1-8.8-13.5-16-23.5-18.2c-10-2.2-21.3,1.3-27.3,9.6c-3.7,5.1-5.3,11.6-5.4,17.9 c-0.4,20.1,13.7,39.6,32.9,45.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1017,785.7c5.9,3.4,10.7,8.6,13.6,14.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1048.6,769.4c3.4-5.4,3.8-12,4.1-18.3c1.2-23,2.3-47.1-7.5-67.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1027,673.7c22.8,14.5,51.5,19.3,77.8,13s49.7-23.6,63.5-46.8c4.4-7.5,7.9-15.7,8.7-24.3 c1.2-12.9-4.1-26.3-13.8-34.9c-9.7-8.6-23.6-12.3-36.3-9.6c-23.6,5.1-38.8,29.2-61.7,36.7c-9.2,3-22.4,0.7-23.7-8.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1143.2,604.9c-5.4,21.5-24.2,39-46,43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1104.6,743.2c10.1-8.5,23.5-12.9,36.6-12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1133.3,780.9c0.4,5,0.2,10.1-0.6,15.1C1134.3,792.2,1133.9,785,1133.3,780.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1145.3,671.3c9.7,16.3,14.9,35.3,14.8,54.3c-0.2,25-8.8,52.2,4,73.7c4.1,6.9,10.1,12.5,13.9,19.5 c3.9,7,5,16.5-0.4,22.4c-3.2,3.4-8.1,5-10.8,8.8c-2.1,2.9-2.5,6.7-2.9,10.3c-1.8,17-3.6,33.9-5.4,50.9c-0.6,6-1.3,12.1-4.3,17.3 c-5.7,9.9-18.1,13.5-29.4,15.2c-20.5,3.1-41.5,2.8-61.8-0.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1162,867.5c-7.7-3.3-15.6-6.1-23.7-8.3c-3.2-0.9-7.4-1.3-9.2,1.5c-1.3,1.9-0.7,4.4,0.1,6.5 c4.2,11.2,15.6,19.2,27.5,19.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1103.9,946.8c0.2,12.8,0.4,25.7,0.6,38.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1064.1,944.5c13.2,8.8,26,18.3,38.1,28.5c0.1-6.6,0.1-13.2,0.2-19.8c0-1.1,0-2.3-0.5-3.2 c-0.9-1.6-2.9-2.2-4.8-2.6c-7.4-1.5-14.9-2.2-22.4-2.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M929.9,794.2c11.7,21.1,13.7,47.3,5.3,70"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M959.7,833.7c-2.6,11.1-7,21.8-13.1,31.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M862.6,995.4c-2.2-15.2-6.1-30.2-11.5-44.6c15.8-0.3,31.6,0.4,47.3,2c17.3,1.8,34.4,4.7,51.5,7.6 c67.1,11.3,134.5,22.8,198.9,44.5c1.2,0.4,2.6,0.9,3.2,2.1c0.5,1,0.2,2.2,0,3.2c-2.4,10.3-4.9,20.5-7.3,30.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M885.3,980.2c30.8-2.7,62.1-0.2,92.2,7.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M840.3,1004.1c-40.9,27.7-80,58.1-117,90.9c-33.8,30-67.3,64.2-78.7,108c-7.2,27.7-5,56.9-9.9,85.1 c-10.1,58.1-49.2,106.3-73.3,160.1c-12.6,28.1-21.2,58.1-24.7,88.7c-3.2,28.2-1.6,58.1,12.4,82.8c20.9,36.8,66.2,56.7,81.1,96.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M582.6,1479.4c-10.7,21.2-12.9,46.6-6,69.3c4.4,14.6,12.3,27.8,18.7,41.6c6.4,13.8,11.4,29,9.5,44.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M599.6,1544.8c3.8,18.2,18.2,33.9,17.4,52.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M747.8,1144.1c-31.6,33.1-48.6,77.6-59.4,122c-7.8,31.9-12.7,64.5-17.7,97c-20.4,133.9-40.9,268.6-37.8,403.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M859.4,1291.5c0.5,13.5,2.1,26.9,3.7,40.3c13,108.2,29,219.1,82.2,314.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M957.9,1662.1c2.5,4.7,4.9,9.4,7.4,14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M905.1,1437.2c19.9,68.3,51.8,133,93.8,190.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1093.4,1038.1c53.5,6.1,108.2,15.4,154,43.7c22.2,13.7,41.5,31.5,59.2,50.7c17.8,19.3,34.1,39.9,48.6,61.8 c36.2,54.7,61,116,85.6,176.8c18.5,45.8,37.3,93.1,36.5,142.5c-0.1,9.1-5.6,21.5-14.1,18.3c-5.6-2.1-6.5-10.2-3.1-15.1 c3.4-4.8,9.4-7,15.2-8.5c29-7.7,59.6-5.3,89.6-2.8c18.6,1.5,37.2,3.1,55.8,4.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1154.8,1068.2c-36.1,65.7-43.3,146.8-19.1,217.8c14.2,41.8,38.5,79.9,50.6,122.4 c7.9,27.4,10.5,56.1,17.4,83.8c22,87.3,87.9,160.3,168.7,199.9c80.8,39.7,174.9,47.8,263.6,32.7c24-4.1,47.7-9.8,71.3-15.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1652.4,1484c41.6,78,66.3,164.9,71.9,253.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1730.9,1477.7c45.6,80.3,72.2,171.4,76.9,263.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1211.9,1637.6c1.2,26.5,12.8,52.5,31.7,71.1c5.2,5.1,11.9,10,19.1,8.9c6.5-1,11.5-6.9,12.9-13.4 c1.4-6.4-0.2-13.2-2.7-19.3c-2.1-4.9-6.7-10.3-11.7-8.5c-5.4,2-4.8,9.8-3,15.3c3.7,11.4,8.2,22.8,15.7,32.2s18.6,16.5,30.6,16.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1259.9,1505.5c23.8,26.1,55.8,44.6,90.3,52.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1247,1456.3c20.2,34.9,56.8,59.9,96.7,65.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1165.4,1080.9c-10.7,25.8-15.5,54-14,81.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1771.1,1533.9c38.4-10.5,74.9-27.5,107.6-50.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1882.9,1535.5c56.6,5,114.1-1.7,168.1-19.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2056.6,1496.1c15.4,4.1,24.3,23.7,17.5,38c-5.2,10.9-16.9,17.1-28,21.7c-26.5,10.9-54.8,17.5-83.4,19.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2067.8,1548.5c3.5,3.9,3,10,0.9,14.8c-5.1,11.6-17.5,18.1-29.4,22.6c-18.4,6.8-37.6,10.9-56.8,15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2064.7,1576.6L2064.7,1576.6c7,5.8,5.6,17.7-0.5,24.5s-15.3,9.7-24,12.4c-18.2,5.6-36.4,11.3-54.6,16.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2061.1,1607.1c3.4,7.2,0.5,16.1-5,21.8c-5.5,5.7-13.1,8.8-20.6,11.4c-72.5,25.1-154,12.8-226.6,37.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1934.7,1576.7c1.8-1,4-1.3,6-0.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1950.7,1609.6c1,0,2,0,3,0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1950.7,
    y1: 1265.9,
    x2: 1425.6,
    y2: 1265.9
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "1193.3,588.1 2329.3,588.1 2329.3,1265.9 2050.9,1265.9  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 2089.9,
    y1: 1162.8,
    x2: 2322.9,
    y2: 1162.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1364.3,
    y1: 1162.8,
    x2: 2001.1,
    y2: 1162.8
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "1581.2,1265.9 1581.2,1331.6 1500.1,1412.8 1748.7,1412.8 1825.1,1336.4 1825.1,1265.9  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1602.3,
    y1: 1331.6,
    x2: 1700.3,
    y2: 1331.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1997,1093.4c-3.4,6.1-8.6,16.8-17.2,16.3c-8.9-0.5-10.1-9.7-5.9-16.1c18.7-28.1,54.9-21.5,67.7,8.1 c6.7,15.4,5.6,33.4,0.6,49.4s-13.8,30.7-22.4,45.1c-9.9,16.4-19.7,32.9-29.6,49.3c-12.8,21.3-25.8,43.3-29.5,67.9 c-3.7,24.6,4.3,52.6,25.6,65.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1996.1,1362.5c-9.2-26.2-2.3-55.6,9.7-80.7c12-25.1,29-47.5,41.3-72.5c12.3-24.9,19.9-54,11.6-80.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2020.9,1299.2c-12.7,22-16.1,49.2-9.4,73.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 2287.7,
    y1: 685.3,
    x2: 2241.7,
    y2: 768.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 2296.6,
    y1: 726.8,
    x2: 2250.7,
    y2: 809.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 2279.5,
    y1: 1057.7,
    x2: 2250.7,
    y2: 1109.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M719.3,845.6c-2.4,0.3-4.2,2-3.8,4.5c0.3,1.8,1.6,3.7,3.4,4.2c1,0.3,2.1,0.2,3-0.3c1.2-0.7,1.5-1.3,2-2.3 c1.1-2,0.9-4.5-0.1-6.5c-1.1-2.1-3.9-4.1-6.3-2.8c-2,1.1-3.2,3.3-3.2,5.6c0,2.4,2,4.8,4.5,4.9c2.2,0,4.3-1.7,4.9-3.9 c0.9-3.3-2.2-6.2-5.4-4.6c-2.7,1.4-4.2,4.1-4.4,7.1c-0.1,1.6,1.4,3,3,3c1.7,0,2.9-1.4,3-3c0.1-0.9,0.7-1.6,1.7-2c-1,0-2,0-3,0 c-0.6-0.3-0.7-1.5-0.8-2c0.2-0.3,0.2-0.4,0.1-0.2c-0.1,0.2-0.1,0.1,0.1-0.1c-0.4,0.2,0,0,0.2-0.1c0.6-0.2,1.4-0.2,1.8,0.4 c0.1,0.2,0.1,0.4,0.2,0.6c0-0.3,0-0.4,0-0.2c0,0.2,0,0.2,0.1-0.2c0,0.1,0,0.1-0.1,0.2c0.2-0.3,0.2-0.3,0-0.1 c0.5-0.4-0.3,0.1,0.3-0.2c-0.8,0.1-1.5,0.2-2.3,0.3c0.4,0.1,0.1,0.1,0.1,0c-0.1,0-0.1-0.1-0.2-0.1c0.1,0.1,0.1,0.1,0.2,0.2 c0,0.1,0.3,0.4,0.1,0.1c0.1,0.2,0.2,0.4,0.1,0.1c0.1,0.2,0.1,0.4,0.2,0.6c-0.1-0.3,0-0.2,0,0.1c0,0.2,0,0.4,0,0 c-0.1,0.5,0.1-0.1-0.1,0.2c-0.2,0.4,0.5-0.6-0.2,0.3c-0.3,0.4-0.3,0.4-0.1,0.2c0.3-0.4,0.7-0.5,1.2-0.4c1.7-0.4,0.7-0.2,1.7,0 c0.3,0.1,0.2,0.1,0-0.1c0.1,0.1,0.2,0.2,0.2,0.3c-0.1-0.4,0,0.6,0,0.3c-0.1,0.9-0.9,2-2.1,2.1c1.6-0.2,3-1.2,3-3 C722.3,847.2,720.9,845.5,719.3,845.6L719.3,845.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1842.2,524.5c0.1-0.1,0.2-0.2,0.4-0.2c-0.3,0.1-0.3,0.1-0.1,0.1c0.2,0,0.2,0-0.1,0c0.4,0.1,0.4,0.1,0,0 c-0.6-0.3,0.3,0.2-0.3-0.1c-0.7-0.4,0.3,0.3-0.3-0.2c-0.1-0.1-0.5-0.6-0.2-0.2c-0.1-0.1-0.2-0.3-0.3-0.5c0.1,0.3,0.1,0.3,0.1,0.1 c-0.1-0.2-0.1-0.2,0,0.2c0-0.4,0-0.3,0,0c0,0.1-0.1,0.1-0.1,0.2c0.2-0.3,0.2-0.3,0-0.1c0.5-0.2-0.2,0-0.3,0.1 c0.2-0.2,0.7-0.2,0.2-0.1c0.2,0,0.3,0,0.5,0c-0.3,0-0.4,0-0.2,0c0.1,0,0.3,0.1,0.4,0.1c-0.3-0.1-0.3-0.1,0,0 c0.1,0,0.8,0.4,0.3,0.1c0.1,0,0.7,0.7,0.2,0.1c0.2,0.3,0.2,0.6,0.1,0.2c0.1,0.7,0.2-0.9,0-0.1c1.7-0.4,3.3-0.9,5-1.3 c-4.6-4.7-12.8,1.7-9.6,7.3c1.9,3.4,7.1,0.3,5.2-3c0.2,0.4,0-0.3,0.1,0.3c0,0.5,0.1,0,0,0.2c-0.2,0.3,0.3-0.3-0.1,0.1 c0.1-0.1,0.7-0.6,0.2-0.2c0.1,0,0.7-0.4,0.3-0.2c-0.3,0.2,0.3-0.1,0.4-0.1c-0.3,0-0.4,0.1-0.2,0.1c0.2,0,0.2,0-0.2,0 c-0.2-0.1-0.7-0.5-0.3-0.1c1.6,1.6,4.5,0.9,5-1.3c1.6-6.5-8-11.1-11.8-5.5c-1.8,2.6-0.9,6.1,1.4,8.1c2.6,2.2,6,2.5,8.6,0.3 c1.2-1,1.1-3.2,0-4.2C1845.2,523.3,1843.4,523.5,1842.2,524.5L1842.2,524.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1494.5,1325.3c-1.7-1-3.8-0.6-5.2,0.7c-1.4,1.3-1.8,3.5-0.9,5.2c0.7,1.4,2.3,2.2,3.9,2.2 c1.5,0,3.3-0.8,4-2.2c0.3-0.7,0.5-1.5,0.3-2.3c-0.2-0.7-0.7-1.4-1.4-1.8c-1.3-0.7-3.4-0.4-4.1,1.1c-0.1,0.1-0.3,0.4,0.1,0 c0.2-0.2,0.2-0.3,0.1-0.2c-0.2,0.2,0,0.1,0.4-0.3c-0.3,0.2,0.4-0.2,0.4-0.2c0,0-0.3,0.1-0.3,0.1c0.3,0,0.5-0.1,0.8-0.1 c-0.1,0-0.3,0-0.4,0c0.3,0,0.5,0.1,0.8,0.1c-0.1,0-0.2-0.1-0.3-0.1c0.5,0.2,0.7,0.3,0.5,0.2c-0.2-0.1-0.1,0,0.4,0.3 c-0.3-0.3,0.4,0.7,0.2,0.3c0.1,0.2,0.1,0.3,0.2,0.5c0-0.1,0-0.2,0-0.2c0,0.3,0.1,0.5,0.1,0.8c0-0.1,0-0.2,0-0.2 c0,0.3-0.1,0.5-0.1,0.8c0.1-0.3,0.2-0.4-0.1,0.3c0.2-0.4-0.5,0.5-0.2,0.2c-0.1,0.1-0.3,0.2-0.4,0.3c0.1,0,0.1-0.1,0.2-0.1 c0,0.1-0.9,0.3-0.2,0.1c-0.3,0-0.5,0.1-0.8,0.1c0.1,0,0.2,0,0.4,0c-0.3,0-0.5-0.1-0.8-0.1c0.5,0.1-0.7-0.4-0.3-0.1 c1.4,0.8,3.3,0.4,4.1-1.1C1496.3,1328,1496,1326.2,1494.5,1325.3L1494.5,1325.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1813.5,1482.2c0.8-0.8,1.6-1.6,2.4-2.4c1.1-1.1,1.2-3.1,0-4.2c-1.2-1.1-3.1-1.2-4.2,0 c-0.8,0.8-1.6,1.6-2.4,2.4c-1.1,1.1-1.2,3.1,0,4.2C1810.5,1483.3,1812.4,1483.4,1813.5,1482.2L1813.5,1482.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M2236.4,1399.9c2.1,1.7,4.8,1.9,7.1,0.4c2.1-1.5,3.6-4.1,3.1-6.7c-0.2-1.3-1-2.6-2.1-3.3 c-1.3-0.8-3.4-0.5-4.8,0c-3,1-5.3,3.4-6.2,6.4c-1.1,3.7,4.7,5.3,5.8,1.6c0.5-1.7,2.1-2.6,3.7-2.5c-0.7-0.3-1.4-0.6-2.1-0.9 c0.6,0.6-0.4-0.5-0.1-0.2c0,0,0-0.1,0-0.2c0-0.2,0-0.2-0.1,0.1c0.2-0.3,0.2-0.3,0,0c-0.1,0.1-0.5,0.7-0.1,0.2 c0,0-0.7,0.7-0.2,0.2c-0.2,0.2-0.7,0.4-0.2,0.2c-0.3,0.2-0.6,0.1-0.1,0.1c0.4,0.1,0.5,0.1,0.1,0c0.2,0,0.3,0.1,0.5,0.3 c-1.3-1-3-1.2-4.2,0C2235.3,1396.8,2235.1,1398.9,2236.4,1399.9L2236.4,1399.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M2432.8,1059.6c-0.8,0-1.6,0-2.4,0c-1.6,0-3.1,1.4-3,3c0.1,1.6,1.3,3,3,3c0.8,0,1.6,0,2.4,0 c1.6,0,3.1-1.4,3-3C2435.7,1061,2434.5,1059.6,2432.8,1059.6L2432.8,1059.6z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloading);
export default __webpack_public_path__ + "static/media/Downloading.87be365e5c7827e532fa6c785d5dd2bf.svg";
export { ForwardRef as ReactComponent };